"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Dsautomobiles = function Dsautomobiles(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.201 0v15.865l9.473-7.377c.102-.077.259-.222.315-.412.049.16.164.277.204.315.686.648 3.802 3.612 4.639 6.148.169.51.264 1.024.264 1.528 0 .434-.095.877-.264 1.317-.38.994-1.226 2.055-2.086 2.96-.367.386-1.955 1.976-2.479 2.5a.903.903 0 0 0-.232.44 2.218 2.218 0 0 0-.041.419L11.99 24l9.47-7.378c.13-.095.339-.294.339-.555 0-.23-.175-.41-.226-.457-.686-.648-3.802-3.612-4.639-6.148a4.886 4.886 0 0 1-.264-1.529c0-.434.095-.876.264-1.316.381-.995 1.227-2.057 2.088-2.962.368-.387 1.955-1.975 2.479-2.499a.89.89 0 0 0 .232-.439c.03-.158.042-.307.042-.419l.004-.297-9.474 7.377c-.104.077-.26.221-.316.41-.057-.189-.214-.334-.315-.41zm.222.757c.53.36 1.117.755 1.858 1.35.7.563 1.469 1.228 2.217 1.997C7.667 5.305 8.56 6.625 8.56 7.92s-.894 2.615-2.063 3.817a24.382 24.382 0 0 1-2.217 1.996c-.741.596-1.305.99-1.835 1.35.606-.474 4.289-3.322 5.255-5.747.188-.473.298-.949.298-1.416 0-.467-.11-.943-.298-1.416C6.735 4.079 3.029 1.23 2.423.757zM21.535.99l-.008.011c-.73.586-4.298 3.766-5.063 5.621-.18.437-.298.876-.298 1.307 0 .474.08.956.247 1.435.858 2.458 4.077 5.355 4.616 5.836-.47-.365-.913-.776-1.571-1.38-.622-.57-1.24-1.243-1.904-2.023-1.038-1.217-1.95-2.555-1.95-3.868 0-1.196.855-2.414 1.973-3.524.69-.685 3.32-2.958 3.958-3.415zm-8.828 7.774c.468.37.962.812 1.62 1.416.62.57 1.24 1.244 1.903 2.023 1.038 1.218 1.95 2.555 1.95 3.868 0 1.196-.855 2.414-1.973 3.524-.689.684-3.334 2.97-3.975 3.43l.007-.012c.736-.59 4.317-3.782 5.081-5.635.18-.437.298-.876.298-1.307 0-.473-.08-.955-.247-1.435-.857-2.458-4.126-5.39-4.664-5.872Z"
  }));
};

Dsautomobiles.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Dsautomobiles.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Dsautomobiles;
exports.default = _default;